import { BasePrice } from '../types';
import { QuoteFeeType, DiscountType } from '@trnsact/trnsact-shared-types';

export enum ChargeType {
  TaxesAndFees = 'taxesAndFees',
}

export const newChargeRow: BasePrice = {
  total: 0,
  netPrice: 0,
  retailPrice: 0,
  wholesalePrice: 0,

  markup: 0,
  markupType: DiscountType.Percent,

  discount: 0,
  discountType: DiscountType.Percent,

  salesTax: 0,
  salesTaxType: DiscountType.Percent,
};

export const sortByOptions = [
  { label: 'All Invoice Items', value: 'all' },
  { label: 'Taxes and Fees', value: 'taxesAndFees' },
  { label: 'Aftermarket', value: 'aftermarket' },
  { label: 'Rebates', value: 'rebates' },
];

export const chargeCategoryOptions = [{ label: 'Taxes and Fees', value: ChargeType.TaxesAndFees }];

export interface ChargeDefinition {
  type: string;
  label: string;
  category: QuoteFeeType;
}

export const allCharges: Record<ChargeType, ChargeDefinition[]> = {
  [ChargeType.TaxesAndFees]: [
    { label: 'Invoice sales tax', type: 'salesTax', category: QuoteFeeType.StateTax },
    { label: 'FET', type: 'FET', category: QuoteFeeType.Other },
    { label: 'License Fees', type: 'licenseFees', category: QuoteFeeType.Other },
    { label: 'Vehicle Inspection Fee', type: 'vehicleInspectionFee', category: QuoteFeeType.Other },
    { label: 'UCC Fee', type: 'uccFee', category: QuoteFeeType.Other },
    { label: 'Dealer Doc Fee', type: 'dealerDocFee', category: QuoteFeeType.Other },
    { label: 'Battery Fee', type: 'batteryFee', category: QuoteFeeType.Other },
    { label: 'Florida Doc Stamp Tax', type: 'floridaDocStampTax', category: QuoteFeeType.Other },
    { label: 'Tire Recycling Fee', type: 'tireRecyclingFee', category: QuoteFeeType.Other },
    { label: 'Finance Markup', type: 'financeMarkup', category: QuoteFeeType.Other },
    { label: 'Cost of Deferred Payments', type: 'costOfDeferredPayments', category: QuoteFeeType.Other },
    { label: 'Installation', type: 'installation', category: QuoteFeeType.Other },
    { label: 'Diesel Emissions Fee', type: 'dieselEmissionsFee', category: QuoteFeeType.Other },
    { label: 'Registration Fees', type: 'registrationFees', category: QuoteFeeType.Other },
    { label: 'Title Fees', type: 'titleFees', category: QuoteFeeType.Other },
    { label: 'GPS Fee', type: 'gpsFee', category: QuoteFeeType.Other },
    { label: 'Lender Doc Fee', type: 'lenderDocFee', category: QuoteFeeType.Other },
    { label: 'Shipping', type: 'shipping', category: QuoteFeeType.Other },
    { label: 'Other Charges (Installation, shipping etc.)', type: 'otherCharges', category: QuoteFeeType.Other },
  ],
};

export const chargeTypesByLabels = Object.values(allCharges).reduce(
  (acc, items) => {
    for (const item of items) {
      acc[item.label] = item.type;
    }
    return acc;
  },
  {} as Record<string, string>
);
